import { LocalFormSchema } from "../logic/applicationUpdateSchema";

type HiddenInputForClearFieldsProps = {
  _clearFields: LocalFormSchema['_clearFields'];
}

const HiddenInputForClearFields: React.FC<HiddenInputForClearFieldsProps> = ({ _clearFields }) => {
  return <>
      {_clearFields && Object.entries(_clearFields).map(([key, value]) =>
      value === 'true' && <input key={`_clearFields.${key}`} type="hidden" name={`_clearFields.${key}`} value={value} />
    )}
  </>
}

export default HiddenInputForClearFields
